/**
 * All GA4 dataLayer variables. Each sendGAEvent must set every key so leftover
 * values from a previous event (e.g. news_click) do not pollute GTM.
 */
const GA4_DATALAYER_VARIABLES = [
  'dlv - article_language',
  'dlv - article_tags',
  'dlv - article_paywall',
  'dlv - event_value',
  'dlv - news_category1',
  'dlv - news_category2',
  'dlv - news_category3',
  'dlv - news_media',
  'dlv - news_url',
  'dlv - publish_date',
  'dlv - ui_element',
  'dlv - ab_test_variant',
  'dlv - login_status',
  'dlv - media_group',
]

/**
 * Set any missing GA4 keys to undefined so GTM does not reuse prior event values.
 * @param {object} eventDataLayer
 * @returns {object}
 */
export function withClearedGa4Variables(eventDataLayer) {
  GA4_DATALAYER_VARIABLES.forEach(variableName => {
    if (eventDataLayer[variableName] == null) {
      eventDataLayer[variableName] = undefined
    }
  })
  return eventDataLayer
}
